<template>
  <div class="page" v-if="info">
    <!-- <NavBar title="默契答题" /> -->
    <div class="wrapper">
      <HomeIcon position="right" />
      <div class="rs-box">
        <img class="avatar" mode="aspectFill" :src="result.avatar" />
        <div class="nickname">
          你和 [<label>{{ info.owner_name }}</label
          >] 的默契指数
        </div>
        <div class="score">{{ result.score }}<label>分</label></div>
        <div class="score-tips">{{ score_tips }}</div>
      </div>
      <div v-if="!temp_try">
        <div class="rank-box" @click="toRank">
          <div class="rank-index">{{ info.rank }}</div>
          <div class="rank-bd">
            <img class="r-avatar" mode="aspectFill" :src="result.avatar" />
            <div class="r-name">{{ info.joiner_name }}</div>
          </div>
          <div class="r-score">{{ result.score }}</div>
        </div>

        <div class="btn-rank" @click="toRank">排行榜>></div>

        <div class="footer">
          <div class="btn-box">
            <div
              class="btn btn-red"
              @click="result.is_me ? toAnswer() : toDetail()"
            >
              {{ result.is_me ? "偷偷看答案" : "参与答题" }}
            </div>
            <!-- <div class="btn btn-red" @click="{{!buttonClicked ? 'toCreate' : ''}}">我也要出题</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import { getToken, setShareInfo } from "@/utils/common";
import NavBar from "@/components/navbar";
import { Toast } from "vant";
import HomeIcon from "@/components/homeIcon";
export default {
  components: { NavBar, HomeIcon },
  data() {
    return {
      info: null,
      result: {},
      rid: "",
      score_tips: "",
      temp_try: 0
    };
  },
  methods: {
    toAnswer() {
      this.$router.push({ name: "answerTacit", query: { rid: this.rid } });
    },
    toRank() {
      this.$router.push({ name: "rank", query: { qid: this.info.qid } });
    },
    getResult() {
      let param = {
        rid: this.rid,
        access_token: getToken()
      };
      questionOnly.get(api.question.getResult, param).then(res => {
        if (res.sta == 0) {
          this.info = res.data;
          this.result = res.data.submit_data;
          this.score_tips = this.getResultTips(res.data.submit_data.score);
        } else {
          Toast(res.msg);
        }
      });
    },
    getResultTips(s) {
      let tips = "啊哈哈，最美不过陌生人！";
      switch (s) {
        case 10:
          tips = "我们还需要更多了解！";
          break;
        case 20:
          tips = "友谊的小船，说翻就翻！";
          break;
        case 30:
          tips = "亲爱的，你听我解释！";
          break;
        case 40:
          tips = "信我！我是爱你的！！";
          break;
        case 50:
          tips = "为我们的友谊干一杯！";
          break;
        case 60:
          tips = "哎呦~还不不错哦！";
          break;
        case 70:
          tips = "一般人答不了这么多~";
          break;
        case 80:
          tips = "竟然还有我不知道的事？！";
          break;
        case 90:
          tips = "这就是心有灵犀！";
          break;
        case 100:
          tips = "只有我最懂你！！";
          break;
      }
      return tips;
    }
  },
  mounted() {
    setShareInfo(false);
    if (this.$route.query.try) {
      this.temp_try = 1;
      let tryResult = JSON.parse(localStorage.getItem("tryResult"));
      if (tryResult) {
        this.info = tryResult;
        this.result = tryResult.submit_data;
        this.score_tips = this.getResultTips(tryResult.submit_data.score);
      }
    } else {
      this.rid = this.$route.query.rid;
      this.getResult();
    }
  },
  destroy() {
    if(localStorage.getItem('tryResult')) {
      localStorage.removeItem('tryResult')
    }
  },
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.wrapper {
  padding: rem(70) 0 rem(30) rem(30);
  min-height: calc(100vh);
  background: linear-gradient(180deg, #0e5ed8 0%, #1b228e 100%);
  background-attachment: fixed;
  height: auto;
  box-sizing: border-box;
}
.rs-box {
  position: relative;
  width: rem(700);
  height: rem(606);
  background: url(https://cdn-xcxcustom.weiyoubot.cn/20210123/dd35b5de071f143dcef166e3bd40a13e.png)
    no-repeat;
  background-size: cover;
  padding-left: rem(30);
  box-sizing: border-box;
}
.avatar {
  position: absolute;
  width: rem(120);
  height: rem(120);
  border-radius: 50%;
  left: rem(31);
}
.nickname {
  padding-top: rem(140);
  font-size: rem(30);
  line-height: rem(45);
}
.score {
  font-size: rem(100);
  color: #1890ff;
  line-height: rem(148);
  font-weight: 900;
}
.score label {
  font-size: rem(40);
}
.score-tips {
  position: relative;
  border-radius: rem(30);
  background: #1a2794;
  max-width: rem(525);
  line-height: rem(88);
  color: #fff;
  font-size: rem(34);
  padding-left: rem(30);
  margin-top: rem(35);
  box-sizing: border-box;
}
.score-tips:before {
  content: "";
  position: absolute;
  left: rem(20);
  top: rem(-20);
  width: 0;
  height: 0;
  border-width: rem(20);
  border-left-color: #1a2794;
  border-bottom-color: #1a2794;
  border-top-color: transparent;
  border-right-color: transparent;
  border-style: solid;
}

.rank-box {
  position: relative;
  display: flex;
  align-items: center;
  width: rem(690);
  height: rem(150);
  margin-top: rem(30);
  background: #fff;
  border-radius: rem(8);
  padding: 0 rem(20);
  box-sizing: border-box;
}
.rank-box::before {
  content: "";
  position: absolute;
  left: rem(8);
  top: rem(6);
  z-index: -1;
  width: rem(690);
  height: rem(150);
  border-radius: rem(8);
  background: #a2a6e2;
}
.rank-index {
  width: rem(70);
  text-align: center;
  white-space: nowrap;
}
.rank-bd {
  flex: 1;
  display: flex;
  align-items: center;
}
.r-avatar {
  width: rem(90);
  height: rem(90);
  border-radius: 50%;
  margin-right: rem(10);
}
.r-name {
  font-size: rem(28);
  width: rem(360);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.r-score {
  font-size: rem(34);
  color: #1890ff;
  padding-right: rem(20);
}
.btn-rank {
  font-size: rem(26);
  line-height: rem(39);
  color: #fff;
  text-align: center;
  padding: rem(15) 0;
  margin-top: rem(30);
  cursor: pointer;
}

.footer {
  width: rem(690);
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: rem(90);
  color: #fff;
  font-size: rem(34);
  border-radius: rem(48);
  box-sizing: border-box;
  cursor: pointer;
}
.btn-blue {
  background: #080e88;
  border: rem(4) solid #fe6895;
}
.btn-red {
  background: #fe6895;
}
.btn-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: rem(30) 0;
}
.btn-box .btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/tacit/tacitResult/tacitDetail.vue